import React, { useState, useEffect } from 'react';
import logo from '../logo_blade.png';
import { auth, db } from '../services/firebase';
import { doc, getDoc, updateDoc, runTransaction } from 'firebase/firestore';
import { buildSlotId } from '../services/agendamentoSlot';

function Confirmacao({ dados, barbearia, onInicio, onVoltar }) {
  const [salvando, setSalvando] = useState(true);
  const [erro, setErro] = useState(false);
  const [isPendente, setIsPendente] = useState(false);

useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps
    async function salvarAgendamento() {
      try {
        const user = auth.currentUser;

        // Guarda: sem usuário autenticado não salva
        if (!user) {
          setErro(true);
          setSalvando(false);
          return;
        }

        // Busca nome no Firestore (fonte confiável) — displayName pode estar vazio
        let nomeCliente = user?.displayName || '';
        if (!nomeCliente && user?.uid) {
          try {
            const userSnap = await getDoc(doc(db, 'clientes', user.uid));
            if (userSnap.exists()) nomeCliente = userSnap.data().nome || '';
          } catch (_) {}
        }
        const telefoneCliente = user?.phoneNumber || '';

        const nomeBarbearia = barbearia?.nome || dados?.barbearia?.nome || '';
        const enderecoBarbearia = barbearia?.endereco?.completo
          || (barbearia?.endereco?.rua
              ? `${barbearia.endereco.rua}, ${barbearia.endereco.numero} — ${barbearia.endereco.bairro}, ${barbearia.endereco.cidade}`
              : barbearia?.endereco || '');

        // Busca exigeAprovacao diretamente do Firestore para garantir valor atualizado
        let exigeAprovacao = barbearia?.exigeAprovacao || false;
        if (barbearia?.id) {
          try {
            const barbSnap = await getDoc(doc(db, 'barbearias', barbearia.id));
            if (barbSnap.exists()) exigeAprovacao = barbSnap.data().exigeAprovacao || false;
          } catch (_) {}
        }
        const statusInicial = exigeAprovacao ? 'pendente' : 'confirmado';
        if (statusInicial === 'pendente') setIsPendente(true);

        const anoAtual = String(new Date().getFullYear());

        // ID determinístico garante que check + write sejam atômicos via transaction:
        // dois clientes tentando o mesmo slot ao mesmo tempo — apenas um vai conseguir.
        const slotId = buildSlotId({
          barbeariaId: barbearia?.id,
          barbeiro: dados?.barbeiro?.nome,
          ano: anoAtual,
          mes: dados?.dia?.mes,
          dia: dados?.dia?.num,
          horario: dados?.horario,
        });

        // Edição mantendo o mesmo barbeiro+horário → o slotId é o mesmo do agendamento
        // original; nesse caso sobrescrevemos o doc existente em vez de barrar como "ocupado".
        const mesmoSlot = !!dados?.reagendarId && dados.reagendarId === slotId;

        const agendRef = doc(db, 'agendamentos', slotId);
        // PII de contato vive em coleção protegida — NÃO entra no doc público de agendamento
        const contatoRef = doc(db, 'atendimentos_contato', slotId);
        await runTransaction(db, async (tx) => {
          const existing = await tx.get(agendRef);
          if (existing.exists() && ['confirmado', 'pendente'].includes(existing.data().status) && !mesmoSlot) {
            const err = new Error('ocupado');
            err.code = 'ocupado';
            throw err;
          }
          tx.set(agendRef, {
            barbeariaId: barbearia?.id || '',
            barbearia: nomeBarbearia,
            endereco: enderecoBarbearia,
            barbeiro: dados?.barbeiro?.nome || '',
            servico: dados?.servico?.nome || '',
            preco: dados?.servico?.preco || '',
            dia: dados?.dia?.num || '',
            mes: dados?.dia?.mes || '',
            ano: anoAtual,
            horario: dados?.horario || '',
            clienteId: user?.uid || '',
            status: statusInicial,
            criadoEm: new Date().toISOString(),
          });
          tx.set(contatoRef, {
            barbeariaId: barbearia?.id || '',
            clienteId: user?.uid || '',
            clienteNome: nomeCliente,
            clienteTelefone: telefoneCliente,
            criadoEm: new Date().toISOString(),
          });
        });
        // Cancela o agendamento antigo só quando ele é um doc diferente do novo.
        // Se for o mesmo slot (mesmoSlot), o doc já foi sobrescrito acima — cancelar
        // aqui apagaria a própria reserva recém-salva.
        if (dados?.reagendarId && !mesmoSlot) {
          try {
            await updateDoc(doc(db, 'agendamentos', dados.reagendarId), { status: 'cancelado' });
          } catch (_) {}
        }

        // Notificação push para o barbeiro
        const tituloNotif = statusInicial === 'pendente' ? 'Nova solicitação! ⏳' : 'Novo agendamento! 💈';
        const msgNotif = `${nomeCliente || 'Cliente'} — ${dados?.horario} · ${dados?.servico?.nome}`;
        fetch('/api/notify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            barbeariaId: barbearia?.id || '',
            titulo: tituloNotif,
            mensagem: msgNotif,
          }),
        }).catch(() => {});

        setSalvando(false);
      } catch (e) {
        setErro(e.code === 'ocupado' ? 'ocupado' : true);
        setSalvando(false);
      }
    }
    salvarAgendamento();
}, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (salvando) {
    return (
      <div style={{
        backgroundColor: '#111111', minHeight: '100vh',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Arial, sans-serif'
      }}>
        <img src={logo} alt="BLADE" style={{ width: '120px', marginBottom: '24px', cursor: 'pointer' }} onClick={onInicio} />
        <p style={{ color: '#8f8f8f', fontSize: '13px' }}>Confirmando agendamento...</p>
      </div>
    );
  }

  if (erro) {
    const slotOcupado = erro === 'ocupado';
    return (
      <div style={{
        backgroundColor: '#111111', minHeight: '100vh',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Arial, sans-serif', padding: '24px'
      }}>
        <div style={{ fontSize: '40px', marginBottom: '16px' }}>{slotOcupado ? '⚠️' : '❌'}</div>
        <p style={{ color: '#e24b4a', fontSize: '14px', textAlign: 'center', marginBottom: '8px', fontWeight: '600' }}>
          {slotOcupado ? 'Horário indisponível' : 'Erro ao confirmar agendamento'}
        </p>
        <p style={{ color: '#9c9c9c', fontSize: '13px', textAlign: 'center', marginBottom: '24px', lineHeight: '1.6' }}>
          {slotOcupado
            ? 'Este horário acabou de ser reservado por outra pessoa. Escolha outro horário.'
            : 'Tente novamente em instantes.'}
        </p>
        <button onClick={onVoltar} style={{
          backgroundColor: '#2d4a2d', color: '#7bc47b',
          border: 'none', borderRadius: '12px', padding: '14px 24px',
          fontSize: '14px', cursor: 'pointer', fontFamily: 'Arial, sans-serif'
        }}>
          Escolher outro horário
        </button>
      </div>
    );
  }

  return (
    <div style={{
      backgroundColor: '#111111', minHeight: '100vh',
      fontFamily: 'Arial, sans-serif', color: '#e8e8e8',
      display: 'flex', flexDirection: 'column'
    }}>

      {/* Cabeçalho */}
      <div style={{ padding: '20px', borderBottom: '1px solid #1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src={logo} alt="BLADE" style={{ height: '36px', cursor: 'pointer' }} onClick={onInicio} />
      </div>

      {/* Conteúdo */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '32px 24px' }}>

        {/* Ícone sucesso */}
        <div style={{ width: '72px', height: '72px', borderRadius: '50%', backgroundColor: '#1a2a1a', border: '2px solid #2d4a2d', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
          <div style={{ width: '36px', height: '36px', borderRadius: '50%', backgroundColor: '#2d4a2d', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', color: '#7bc47b', fontWeight: '700' }}>
            ✓
          </div>
        </div>

        <h1 style={{ fontSize: '28px', fontWeight: '700', letterSpacing: '3px', margin: '0 0 6px 0', textAlign: 'center' }}>
          {isPendente ? 'SOLICITADO!' : 'AGENDADO!'}
        </h1>
        <p style={{ fontSize: '13px', color: '#8f8f8f', textAlign: 'center', margin: '0 0 28px 0', lineHeight: '1.6' }}>
          {isPendente
            ? <>Sua solicitação foi enviada.<br />Aguarde a confirmação da barbearia.</>
            : <>Sua reserva está confirmada.<br />Até lá, chefe.</>
          }
        </p>

        {/* Card resumo */}
        <div style={{ width: '100%', backgroundColor: '#181818', border: '0.5px solid #252525', borderRadius: '14px', padding: '16px', marginBottom: '20px' }}>
          {[
            { label: 'Barbearia', valor: barbearia?.nome || '' },
            { label: 'Barbeiro',  valor: dados?.barbeiro?.nome || '' },
            { label: 'Serviço',   valor: dados?.servico?.nome || '' },
            { label: 'Data',      valor: `${dados?.dia?.num || ''} de ${dados?.dia?.mes || ''} — ${dados?.horario || ''}` },
            barbearia?.endereco ? {
              label: 'Endereço',
              valor: barbearia.endereco?.completo
                || (barbearia.endereco?.rua
                    ? `${barbearia.endereco.rua}, ${barbearia.endereco.numero} — ${barbearia.endereco.bairro}`
                    : typeof barbearia.endereco === 'string' ? barbearia.endereco : '')
            } : null,
          ].filter(Boolean).map((item, i, arr) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: i < arr.length - 1 ? '0.5px solid #1a1a1a' : 'none' }}>
              <span style={{ fontSize: '12px', color: '#7d7d7d' }}>{item.label}</span>
              <span style={{ fontSize: '12px', color: '#ccc', fontWeight: '500' }}>{item.valor}</span>
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', paddingTop: '12px', marginTop: '4px', borderTop: '0.5px solid #252525' }}>
            <span style={{ fontSize: '13px', color: '#9c9c9c' }}>Valor do serviço</span>
            <span style={{ fontSize: '20px', fontWeight: '600', color: '#c9a84c' }}>
              {dados?.servico?.preco || 'R$ 75'}
            </span>
          </div>
        </div>

        <button onClick={onInicio} style={{ width: '100%', backgroundColor: '#2d4a2d', color: '#7bc47b', border: 'none', borderRadius: '12px', padding: '14px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', marginBottom: '10px', letterSpacing: '0.5px' }}>
          VOLTAR AO INÍCIO
        </button>

        <button onClick={onVoltar} style={{ width: '100%', backgroundColor: 'transparent', color: '#8f8f8f', border: '0.5px solid #252525', borderRadius: '12px', padding: '12px', fontSize: '13px', cursor: 'pointer' }}>
          Fazer outro agendamento
        </button>

      </div>
    </div>
  );
}

export default Confirmacao;